import { useCallback, useRef } from 'react';

import { gql, useMutation } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const CREATE_PRODUCT_LANDING_PERSONALIZATION_MUTATION = gql`
  mutation CreateProductLandingPersonalization($input: CreateProductLandingPersonalizationInput!) {
    createProductLandingPersonalization(input: $input) {
      cacheHit
      cacheMissReason
      sections {
        section
        items {
          key
          copy
        }
      }
    }
  }
`;

export function useProductLandingPersonalization() {
  const [createProductLandingPersonalization, { error }] = useMutation(
    CREATE_PRODUCT_LANDING_PERSONALIZATION_MUTATION,
    { noThrow: true }
  );

  useError(error);

  // useMutation returns a new function reference after each execution, which would
  // cause the personalization useEffect in useProductLanding to re-fire in a loop.
  // Using a ref breaks that cycle while always calling the latest mutation fn.
  const mutateRef = useRef(createProductLandingPersonalization);
  mutateRef.current = createProductLandingPersonalization;

  const requestPersonalization = useCallback(async (input) => {
    const response = await mutateRef.current({
      variables: { input }
    });

    return response?.data?.createProductLandingPersonalization ?? null;
  }, []);

  return { requestPersonalization };
}
